import { useEffect } from "react";
import { useLoaderData } from "react-router";

const ChatbotWidgetDemo = () => {

    const { id , o } = useLoaderData();
    console.log({ id , o})
    const script = document.createElement('script');
    script.src = process.env.REACT_APP_GLOBOT_JS;
    
    document.body.appendChild(script);

    const handleMessage = (e => {
        console.log('handleMessage chatbotwidgetdemo', e);
        if (document.getElementById("chat-bubble")) {
            document.getElementById("chat-bubble").style.backgroundColor = e.data.color;
            const ifr = document.getElementById('globot-iframe');
            console.log('ifr', ifr);
            if (ifr) {
                ifr.contentWindow.postMessage(e.data);
            }
        }
    });

    useEffect(() => {
        setTimeout(() => {
            var chatConfig = {
                botId: id,
                o:o
            };
            if (window.initializeChatWidget) {
                if (!document.getElementById('chat-container')) {
                    window.initializeChatWidget(chatConfig);
                    window.onmessage = handleMessage;
                }
            }
        }, 500)

        setTimeout(() => {
            if (window.initializeChatWidget)
                window.toggleChat();
        }, 1500);

        return (() => {
            document.body.removeChild(script);
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export default ChatbotWidgetDemo;